import React, { useState } from 'react';
import './interactive.css';

const KubernetesAutoscaler = () => {
  const [cpuLoad, setCpuLoad] = useState(30);
  const [isSimulatingCrash, setIsSimulatingCrash] = useState(false);

  // Determine pods based on CPU load (HPA logic: target 50% CPU)
  // At 20-40%: 2 pods. At 41-60%: 3 pods. At 61-75%: 4 pods. At 76-90%: 5 pods. >90%: 6 pods.
  const targetPodCount = cpuLoad <= 40 ? 2 : cpuLoad <= 60 ? 3 : cpuLoad <= 75 ? 4 : cpuLoad <= 90 ? 5 : 6;

  const pods = Array.from({ length: targetPodCount }).map((_, idx) => ({
    id: `pod-web-${1042 + idx * 87}`,
    status: isSimulatingCrash && idx === 0 ? 'CrashLoopBackOff' : 'Running',
    node: `worker-node-0${(idx % 2) + 1}`,
    restarts: isSimulatingCrash && idx === 0 ? 1 : 0
  }));

  const handleSimulateCrash = () => {
    setIsSimulatingCrash(true);
    setTimeout(() => {
      setIsSimulatingCrash(false);
    }, 2500);
  };

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-dharmachakra" style={{ color: '#3b82f6' }}></i> Kubernetes HPA (Horizontal Pod Autoscaler) Simulator
        </div>
        <div style={{ fontSize: '0.78rem', color: 'var(--text-color)' }}>Cluster: On-Premise Multi-Cluster</div>
      </div>

      <div className="interactive-content">
        <div className="k8s-controls">
          <div className="k8s-slider-label">
            <span><i className="fas fa-tachometer-alt"></i> Gesimuleerde Belasting / CPU Verbruik:</span>
            <span style={{ color: cpuLoad > 75 ? '#ef4444' : cpuLoad > 50 ? '#f59e0b' : '#10b981', fontWeight: 700 }}>
              {cpuLoad}% CPU (Target: 50%)
            </span>
          </div>

          <input 
            type="range" 
            min="15" 
            max="100" 
            value={cpuLoad} 
            onChange={(e) => setCpuLoad(Number(e.target.value))}
            className="k8s-slider"
          />

          <div className="k8s-metrics">
            <span className="k8s-metric-pill">
              <i className="fas fa-cube"></i> Actieve Replicas: <strong>{targetPodCount}</strong>
            </span>
            <span className="k8s-metric-pill">
              <i className="fas fa-microchip"></i> HPA Status: <strong>{cpuLoad > 50 ? 'Opschalen (Scale-Up)' : 'Stabiel (Normal)'}</strong>
            </span>
            <span className="k8s-metric-pill">
              <i className="fas fa-heartbeat"></i> Self-Healing: <strong>Actief</strong>
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
          <span style={{ fontSize: '0.84rem', fontWeight: 600, color: 'var(--title-color)' }}>
            Pod Overzicht in Namespace: <code>production</code>
          </span>
          <button 
            type="button" 
            className="ansible-btn ansible-btn--secondary" 
            style={{ padding: '0.3rem 0.8rem', fontSize: '0.75rem' }}
            onClick={handleSimulateCrash}
            disabled={isSimulatingCrash}
          >
            <i className="fas fa-bomb"></i> {isSimulatingCrash ? "K8s herstelt pod..." : "Simuleer Pod Crash"}
          </button>
        </div>

        <div className="k8s-pods-grid">
          {pods.map((pod) => (
            <div 
              key={pod.id} 
              className={`k8s-pod ${pod.status === 'Running' ? 'k8s-pod--running' : 'k8s-pod--creating'}`}
              style={pod.status === 'CrashLoopBackOff' ? { borderColor: '#ef4444', background: 'rgba(239,68,68,0.1)' } : undefined}
            >
              <div className="k8s-pod-icon">
                <i className={pod.status === 'CrashLoopBackOff' ? "fas fa-exclamation-triangle" : "fas fa-cube"}></i>
              </div>
              <div className="k8s-pod-name">{pod.id}</div>
              <div 
                className="k8s-pod-status"
                style={{ color: pod.status === 'CrashLoopBackOff' ? '#ef4444' : '#10b981' }}
              >
                {pod.status}
              </div>
              <div style={{ fontSize: '0.65rem', color: 'var(--text-color)', marginTop: '0.2rem' }}>
                {pod.node}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KubernetesAutoscaler;
